import React from 'react';
import CheckboxAsRadioWrapper from '../Wrappers/CheckboxAsRadioWrapper';

export default class Limited extends React.Component {
  componentWillMount() {
    this.props.field('body').validations.val = 'plan';
  }

  render() {
    const { field } = this.props;
    const plan = field('plan');

    if (!plan) return null;

    return (
      <div style={{ marginBottom: '30px' }}>
        <p>
          You have hit your FREE account limit of{' '}
          {this.props.social.get('limit')} posts per week.
        </p>
        <p>Would you like to upgrade now for unlimited posts?</p>
        <label className="form-check-label">
          <CheckboxAsRadioWrapper
            {...this.props}
            input={plan}
            value="basic"
            onChange={this.props.onChange}
            suppressError={true}
            valid={this.props.valid}
            inputClass="form-check-input"
          />{' '}
          <strong>Basic | $85/mo</strong>
        </label>
        <ul style={{ listStyle: 'circle' }}>
          <li>
            Create unlimited new events, specials, or general posts each week
            and share them with your followers
          </li>
        </ul>

        <label className="form-check-label">
          <CheckboxAsRadioWrapper
            {...this.props}
            input={plan}
            value="enhanced-full"
            onChange={this.props.onChange}
            suppressError={true}
            valid={this.props.valid}
            inputClass="form-check-input"
          />{' '}
          <strong>Enhanced | $295/mo</strong>
        </label>
        <ul style={{ listStyle: 'circle' }}>
          <li>Create deals and keep 100% of the revenue*</li>
          <li>
            Get featured in search results with a big, beautiful, more prominent
            photo
          </li>
          <li>
            Create unlimited new events, specials, or general posts each week
            and share them with your followers
          </li>
        </ul>
        <div style={{ textAlign: 'right' }}>
          <small>* Excluding credit card transaction fee</small>
        </div>

        {plan.validations.errors.length > 0 && (
          <ul>
            <li className="error">Please choose a plan</li>
          </ul>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Social/Limited.js